import * as o from "react";
import { forwardRef as t } from "react";
const a = t(function(e, r) {
  return /* @__PURE__ */ o.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ o.createElement(
      "path",
      {
        d: "M16 11L12 15L8 11",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      }
    )
  );
});
export {
  a as ChevronSmallDown
};
